import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	inactivePlansDirectoryNoAccessPermissionTitle: {
		id: 'inactive-plans-directory-base.common.inactive-plans-directory-no-access-permission-title',
		defaultMessage: "This page isn't available",
		description:
			'This is a header for error flag showing when the user does not have JSW Software access.',
	},
	inactivePlansDirectoryNoAccessPermissionDescriptionSpork: {
		id: 'inactive-plans-directory-base.common.inactive-plans-directory-no-access-permission-description-spork',
		defaultMessage:
			'Your Jira permissions have changed, and you can no longer view this page. Contact an administrator to restore access.',
		description:
			'This is a description for error flag showing when the user does not have JSW Software access.',
	},
});
